import service from './request'
import {aesEncrypt} from "@/util/aesEncrypt";

export const {encrypt} = aesEncrypt()

function processingData(data) {
    let obj = {};
    let params = JSON.parse(JSON.stringify(data));
    Object.keys(params).forEach(key => {
        const val = params[key];
        if (val === '' || val === null || val === undefined) {
            delete params[key];
        } else {
            if (typeof val === 'number' || typeof val === 'boolean') {
                params[key] = String(val);
            }
        }
    });
    obj.dataJson = encrypt(JSON.stringify(params));
    return obj;
}

const excludeApi = ['sys/file/upload']

const http = {
    /**
     * GET 请求
     * @param {string} url - 请求地址（相对路径，基于 baseURL）
     * @param {object} [params] - 请求参数（会拼接到 URL 上）
     * @returns {Promise} - 响应结果
     */
    get(url, params) {
        return service({
            method: 'get',
            url,
            params // GET 请求参数通过 params 传递（Axios 会自动拼接到 URL）
        })
    },

    /**
     * POST 请求
     * @param {string} url - 请求地址
     * @param newData
     * @returns {Promise} - 响应结果
     */
    post(url, newData) {
        let data;
        const excludeApiStatus = excludeApi.some(item => url.includes(item))
        if (excludeApiStatus) {
            data = newData
        } else {
            if (newData) data = processingData(newData)
        }
        return service({
            method: 'post',
            url,
            data // POST 请求参数通过 data 传递（Axios 会转为 JSON 格式）
        })
    },

    /**
     * PUT 请求（更新资源）
     * @param {string} url - 请求地址
     * @param {object} [data] - 更新参数（JSON 格式）
     * @returns {Promise} - 响应结果
     */
    put(url, data) {
        return service({
            method: 'put',
            url,
            data // PUT 请求通常用 data 传递参数（而非 params）
        })
    },

    /**
     * DELETE 请求（删除资源）
     * @param {string} url - 请求地址
     * @param {object} [params] - 请求参数（拼接到 URL 上）
     * @returns {Promise} - 响应结果
     */
    delete(url, params) {
        return service({
            method: 'delete',
            url,
            params
        })
    }
}

export default http
